<template>
  <div style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div
      v-if="init"
      style="height: 100%"
      class="d-flex flex-column justify-center align-center"
    >
      <v-card
        class="
          pa-6
          py-10
          mx-2
          my-4
          d-flex
          flex-column
          justify-center
          align-center
        "
        elevation="0"
      >
        <img :src="logoUrl" style="width: 150px" />
        <!-- <p class="headline font-weight-light text-center">Activate Account</p> -->
        <div v-if="submitSuccess" class="d-flex flex-column justify-center">
          <p class="headline text-center my-4">
            Your account has been updated.
          </p>
          <v-btn color="primary" depressed rounded @click="redirectLogin"
            >Login Here</v-btn
          >
        </div>
        <div v-if="!user" class="d-flex flex-column justify-center">
          <p class="headline text-center my-4">
            The activation code is no longer valid
          </p>
          <v-btn color="primary" depressed rounded @click="redirectLogin"
            >Login Here</v-btn
          >
        </div>
        <div v-if="!submitSuccess && user" class="ma-4 d-flex justify-center">
          <a v-if="!awaitOTP" id="profile-picture-trigger">
            <v-avatar left color="grey" size="100" class="profile-picture">
              <img v-if="imageURL" :src="imageURL" />
              <v-icon v-else dark x-large>mdi-account</v-icon>
            </v-avatar>
          </a>
          <!-- <avatar-cropper
            trigger="#profile-picture-trigger"
            :upload-handler="profilePictureUploadHandler"
            :labels="cropperLabels"
          /> -->
        </div>
        <v-form
          v-if="!submitSuccess && user"
          ref="form"
          v-model="formValid"
          style="width: 100%"
        >
          <v-container v-if="!awaitOTP">
            <v-row>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field
                  v-model="username"
                  label="Username"
                  :rules="usernameRules"
                  prepend-inner-icon="mdi-account-check"
                  :disabled="user.status !== 'temporary'"
                  required
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field
                  v-model="email"
                  label="Email"
                  disabled
                  prepend-inner-icon="mdi-email"
                  required
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field
                  v-model="firstName"
                  label="First Name"
                  :rules="nameRules"
                  prepend-inner-icon="mdi-account"
                  required
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field
                  v-model="lastName"
                  label="Last Name"
                  :rules="nameRules"
                  prepend-inner-icon="mdi-account"
                  required
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-menu
                  v-model="birthdayMenu"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="birthday"
                      label="Birthday"
                      prepend-inner-icon="mdi-calendar-month"
                      v-bind="attrs"
                      dense
                      outlined
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="birthday"
                    no-title
                    scrollable
                    @input="birthdayMenu = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field
                  v-model="contactNumber"
                  label="Contact Number"
                  prepend-inner-icon="mdi-phone"
                  :rules="phMobileRules"
                  required
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="user.status === 'temporary'">
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-text-field
                  v-model="oldPass"
                  label="Old Password"
                  required
                  prepend-inner-icon="mdi-lock-open"
                  disabled
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-text-field
                  v-model="newPass"
                  label="New Password"
                  :rules="passwordRules"
                  type="password"
                  prepend-inner-icon="mdi-lock"
                  required
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-text-field
                  v-model="oldPass"
                  label="Enter your current password to continue"
                  type="password"
                  required
                  prepend-inner-icon="mdi-lock-open"
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-container v-if="awaitOTP && !submitSuccess">
          <p class="text-center mb-4">Enter One Time Pin:</p>
          <div id="divOuter">
            <div id="divInner">
              <input
                id="partitioned"
                v-model="OTP"
                type="text"
                maxlength="4"
                onKeyPress="if(value.length==4) return false;"
              />
            </div>
          </div>
          <p
            v-if="OTPResendTimeout > 0"
            class="mt-2 caption text-center"
            style="color: grey"
          >
            Resend OTP in ({{ OTPResendTimeout }})
          </p>
          <p
            v-else
            class="mt-2 caption text-center"
            style="text-decoration: underline; cursor: pointer"
            @click="submit"
          >
            Resend OTP
          </p>
        </v-container>
        <div v-if="!submitSuccess && user && !awaitOTP">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              depressed
              :disabled="!formValid || OTPResendTimeout > 0"
              @click="submit"
              >Activate Account</v-btn
            >
            <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
          </v-card-actions>
          <p
            v-if="OTPResendTimeout > 0"
            class="caption text-center"
            style="color: grey"
          >
            Submit Activation in ({{ OTPResendTimeout }})
          </p>
        </div>
        <v-card-actions v-if="awaitOTP && !submitSuccess">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="OTP.length < 4"
            @click="submitOTP"
            >Submit</v-btn
          >
          <v-btn color="grey" text @click="back">Back</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar">
      {{ snackMessage }}
      <v-btn color="blue" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { dayjs } from '../util/date'

export default {
  props: ['code'],
  data() {
    return {
      firstName: '',
      lastName: '',
      oldPass: '',
      newPass: '',
      username: '',
      email: '',
      profilePicture: null,
      nameRules: [(v) => (v && v.length >= 0) || 'This field is required.'],
      usernameRules: [
        (v) => !v.includes(' ') || 'Username cannot contain spaces',
        (v) => v.length >= 5 || 'Username must be 5 characters or longer'
      ],
      passwordRules: [
        (v) => {
          const pattern = /(?=.*\d)(?=.*[A-Za-z])/
          return (
            pattern.test(v) ||
            'Password must contain at least one number and letter'
          )
        },
        (v) => v.length >= 8 || 'Password must contain at least 8 characters'
      ],
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || 'Please use the format +63xxxxxxxxxx'
        }
      ],
      sectionBackgroundStyle: `background-image: url(${process.env.BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`,
      user: null,
      submitSuccess: false,
      loading: true,
      init: false,
      cropperLabels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      birthday: dayjs()
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .format('YYYY-MM-DD'),
      birthdayPicker: dayjs()
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .format('YYYY-MM-DD'),
      birthdayMenu: false,
      contactNumber: '',
      formValid: false,
      imageBlob: null,
      imageURL: null,
      snackbar: false,
      snackMessage: '',
      awaitOTP: false,
      OTP: '',
      OTPResendTimeout: 0
    }
  },
  computed: {
    logoUrl() {
      return `${process.env.BASE_URL}images/logo_text_bottom.png`
    }
  },
  async created() {
    this.user = await this.$store.dispatch('users/fetchActivationUserAction', {
      activationCode: this.code
    })
    this.oldPass =
      this.user.status === 'temporary' ? this.user.activationCode : ''
    this.username = this.user.status !== 'temporary' ? this.user.username : ''
    this.firstName = this.user.firstName
    this.lastName = this.user.lastName
    this.email = this.user.email1
    this.contactNumber = this.user.contactNumber1
    this.loading = false
    this.init = true
  },
  methods: {
    async submit() {
      if (this.OTPResendTimeout <= 0) {
        this.loading = true
        try {
          const OTP = await this.$store.dispatch('users/sendOTPRequestAction', {
            userId: this.user.userId,
            contactNumber1: this.contactNumber,
            oldPass: this.oldPass,
            username: this.username
          })
          if (OTP) {
            this.OTPResendTimeout = 30
            this.awaitOTP = true
            this.snackMessage = 'One time pin sent!'
            this.snackbar = true
            this.loading = false
            let timerId = setInterval(() => {
              this.OTPResendTimeout -= 1
            }, 1000)

            setTimeout(() => {
              clearInterval(timerId)
              this.OTPResendTimeout = 0
            }, 30000)
          }
          // this.submitSuccess = true
          // this.loading = false
        } catch (err) {
          this.OTPResendTimeout = 0
          this.awaitOTP = false
          this.snackMessage = err
          this.snackbar = true
          this.submitSuccess = false
          this.loading = false
        }
      }
    },
    cancel() {
      this.$router.replace('/login')
    },
    back() {
      this.OTP = ''
      this.awaitOTP = false
    },
    async submitOTP() {
      this.loading = true
      try {
        await this.$store.dispatch('users/activateUserByIdAction', {
          userId: this.user.userId,
          username: this.username,
          firstName: this.firstName,
          lastName: this.lastName,
          oldPass: this.oldPass,
          newPass: this.newPass,
          contactNumber1: this.contactNumber,
          birthday: dayjs(this.birthday).format(),
          profilePicture: this.imageBlob,
          OTP: this.OTP
        })
        this.loading = false
        this.submitSuccess = true
      } catch (err) {
        this.snackMessage = err
        this.snackbar = true
        this.submitSuccess = false
        this.loading = false
      }
    },
    redirectLogin() {
      this.$router.replace('/login')
    },
    profilePictureUploadHandler(cropper) {
      cropper.getCroppedCanvas().toBlob((blob) => {
        this.imageBlob = blob
        this.imageURL = URL.createObjectURL(blob)
        // this.$store.dispatch('users/updateUserProfilePictureAction', {profilePicture: blob}).then(() => {
        //   this.$router.go()
        // })
      })
    }
  }
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #662d91),
    color-stop(100%, #798eea)
  );
  background: -webkit-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -ms-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: linear-gradient(135deg, #662d91 0%, #798eea 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#662d91', endColorstr='#798eea', GradientType=1 );
}
.v-card {
  border-radius: 12px !important;
}

#partitioned {
  padding-left: 15px;
  letter-spacing: 40px;
  border: 0;
  background-image: linear-gradient(
    to left,
    black 70%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 50px 2px;
  background-repeat: repeat-x;
  background-position-x: 35px;
  width: 220px;
  min-width: 220px;
}

#partitioned:focus {
  outline-width: 0;
}

#divInner {
  left: 0;
  position: sticky;
}

#divOuter {
  width: 190px;
  overflow: hidden;
}
</style>
